import React, {Component} from 'react'
import Text from './fields/Text'
import Email from './fields/Email'
import Password from './fields/Password'
import Textarea from './fields/Textarea'
import Number from './fields/Number'
import File from './fields/File'

export default class Field extends Component {
    setField(name, value, error) {
        this.props.setValue(name, value, error)
    }

    render() {
        if (this.props.type === 'email') {
            return (
                <Email
                    params={this.props}
                    setField={this.setField.bind(this)}
                    state={this.props.state}
                />
            );
        }
        if (this.props.type === 'text') {
            return (
                <Text
                    params={this.props}
                    setField={this.setField.bind(this)}
                    state={this.props.state}
                />
            );
        }
        if (this.props.type === 'textarea') {
            return (
                <Textarea
                    params={this.props}
                    setField={this.setField.bind(this)}
                    state={this.props.state}
                />
            );
        }
        if (this.props.type === 'password') {
            return (
                <Password
                    params={this.props}
                    setField={this.setField.bind(this)}
                    state={this.props.state}
                />
            );
        }
        if (this.props.type === 'number') {
            return (
                <Number
                    params={this.props}
                    setField={this.setField.bind(this)}
                    state={this.props.state}
                />
            );
        }
        if (this.props.type === 'file') {
            return (
                <File
                    params={this.props}
                    setField={this.setField.bind(this)}
                    state={this.props.state}
                />
            );
        }

        return (
            <div>No type</div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/common/Field.js